<template>
<div>
    <form-errors :errors="formErrors" v-if="!hideFormErrors" />

    <div class="form-row">
        <div class="col">
            <form-input label="Company" v-model="formData.company" :errors="errors.company" type="select" :options="companyOptions"/>
        </div>
    </div>

    <form-input label="First Name" v-model="formData.first_name" :errors="errors.first_name" type="text" maxlength="25" />
    <form-input label="Middle Name" v-model="formData.middle_name" :errors="errors.middle_name" type="text" maxlength="25" />
    <form-input label="Last Name" v-model="formData.last_name" :errors="errors.last_name" type="text" maxlength="25" />

    <div class="form-row">
        <div class="col-8 col-sm-6">
            <form-input label="Suffix" v-model="formData.suffix" :errors="errors.suffix" type="select" :options="suffixOptions" />
        </div>
    </div>

    <form-input label="Email Address" v-model="formData.email" :errors="errors.email" type="email" />

    <div class="form-row">
        <div class="col-8 col-sm-6">
            <form-input label="Social Security Number" v-model="formData.ssn" :errors="errors.ssn" type="ssn" />
        </div>
    </div>

    <div class="form-row">
        <div class="col-8 col-sm-6">
            <form-input label="Date of Birth" v-model="formData.dob" :errors="errors.dob" type="date" placeholder="MM/DD/YYYY" />
        </div>
    </div>

</div>
</template>

<script>
import FormInput from '@/components/FormInput'
import FormErrors from '@/components/FormErrors'
import FormMixin from '@/mixins/Form'
import { dobDateRule } from '@/utils'

export default {
    mixins: [FormMixin],
    components: { FormInput, FormErrors },
    props: {
        client: { required: true },
        employerHire: { required: false, default: null },
        hideFormErrors: { required: false, default: false },
    },
    computed: {
        companies() {
            return this.client.companies || []
        },
        companyOptions() {
            return this.companies.map(c => ({ text: c.name, value: c.id }))
        },
    },
    watch: {
        client() { this.reset() },
        employerHire() { this.reset() },
    },
    data() {
        return {
            suffixOptions: [
                {text: 'JR', value: 'JR'},
                {text: 'SR', value: 'SR'},
                {text: 'II', value: 'II'},
                {text: 'III', value: 'III'},
                {text: 'IV', value: 'IV'},
            ],
            formLabels: {
                ssn: 'SSN',
                dob: 'Date of Birth',
            },
            formRules: {
                company: { presence: { allowEmpty: false } },
                first_name: { presence: { allowEmpty: false } },
                last_name: { presence: { allowEmpty: false } },
                email: {
                    email: true,
                    presence: { allowEmpty: false },
                },
                ssn: { presence: { allowEmpty: false }, ssn: true },
                dob: { presence: { allowEmpty: false }, date: dobDateRule() },
            },
            formData: this.makeFormData(),
        }
    },
    methods: {
        makeFormData() {
            const eh = this.employerHire
            return {
                company: eh?.company?.id || '',
                first_name: eh?.first_name || '',
                middle_name: eh?.middle_name || '',
                last_name: eh?.last_name || '',
                suffix: eh?.suffix || '',
                email: eh?.email || '',
                ssn: eh?.ssn || '',
                dob: eh?.dob || '',
            }
        },
        onSubmit() {
            // if (!this.validate()) {
            //     return
            // }
            this.$emit('updated', this.getFormData())
        },
        reset() {
            this.formErrors = []
            FormMixin.methods.reset.call(this)
        },
    },
}
</script>
